<template>
  <b-overlay :show="fullSearchIsRunning" rounded>
    <b-row>
      <b-col sm="12">
        <b-overlay :show="searchIsRunning" rounded>
          <b-card>
            <h3 class="chr-h3"> <b-icon icon="globe2"></b-icon> CIRCUITE</h3>
            <SearchForm
              @search="$event => onSearch($event)"
              />
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
    <template v-if="searchIsDone">
      <template v-for="(result, resultIndex) in results">
        <Result :key="'result' + resultIndex"
          :result="result"
          :params="params"
          :searchIsDone="isSelected(resultIndex) ? fullSearchIsDone : false"
          :results="isSelected(resultIndex) ? fullSearchResults : []"
          :hasTransport="isSelected(resultIndex) ? hasTransport : false"
          :selectedDate="isSelected(resultIndex) ? selectedDate : null"
          @select="$event => selectResult(resultIndex, $event)"
          @search="$event => onFullSearch($event)"
           />
      </template>
    </template>
  </b-overlay>
</template>

<script>
import viewMixin from '../shared/mixins/search_views'
import { search } from 'b2b-common/services/api/cache'
import { search as fullSearch } from 'b2b-common/services/api/package'
import SearchForm from './components/search_form'
import Result from './components/result.vue'

export default {
  components: {
    SearchForm,
    Result
  },
  mixins: [viewMixin],
  data () {
    return {
      results: [],
      searchIsDone: false,
      fullSearchResults: [],
      fullSearchIsDone: false,
      hasTransport: false,
      searchIsRunning: false,
      fullSearchIsRunning: false,
      selectedResultIndex: null,
      selectedDate: null,
      params: {}
    }
  },
  methods: {
    async onSearch (params) {
      this.searchIsRunning = true
      this.searchIsDone = false
      this.fullSearchIsDone = false
      this.fullSearchResults = []
      this.selectedDate = null
      this.results = []
      try {
        this.params = { ...params }
        this.results = await search(params)
        this.searchIsDone = true
      } catch (e) {
      } finally { this.searchIsRunning = false }
    },
    async onFullSearch (params) {
      this.fullSearchIsRunning = true
      this.fullResults = []
      this.fullSearchIsDone = false
      try {
        const res = await fullSearch(params)
        this.fullSearchResults = res.results
        this.hasTransport = res.has_transport
        this.fullSearchIsDone = true
      } catch (e) {
      } finally { this.fullSearchIsRunning = false }
    },
    isSelected (index) {
      return this.selectedResultIndex === index
    },
    selectResult (index, date) {
      this.selectedResultIndex = index
      this.selectedDate = date
    }
  }
}
</script>

<style lang="scss">
  .chr-h3{
    border-bottom: 1px solid #424242;
    padding-bottom: .7rem;
  }
</style>
